import React, { useState } from 'react'
import styled from 'styled-components'
import { Col, Row } from 'react-bootstrap'
import { Title } from 'components'
import classnames from 'classnames'
import { navigate } from 'raviger'

const SearchSelector = ({ selected = 'programs' }) => {
  const [selectedSearch, setSelectedSearch] = useState(selected)

  const handleTitleClick = (search) => {
    setSelectedSearch(search)
    navigate(`/search/advanced/${search}`)
  }

  return (
    <RowStyled className="mb-4">
      <Col md={3}>
        <Title
          className={classnames(
            selectedSearch === 'programs' ? 'selected' : 'unselected'
          )}
          onClick={() => handleTitleClick('programs')}
        >
          Program Search
        </Title>
      </Col>
      <Col md={4}>
        <Title
          className={classnames(
            selectedSearch === 'organizations' ? 'selected' : 'unselected'
          )}
          onClick={() => handleTitleClick('organizations')}
        >
          Organization Search
        </Title>
      </Col>
    </RowStyled>
  )
}

const RowStyled = styled(Row)`
  legend {
    cursor: pointer;
  }

  .selected {
    color: ${({ theme }) => theme.palette.primary[0]};
    text-decoration: underline;
  }

  .unselected {
    color: gray;
  }
`

// const Container = styled(Nav)`
//   margin-bottom: 1rem;
//   > .nav-item > .nav-link {
//     color: gray;

//     &.active {
//       color: ${({ theme }) => theme.palette.primary[0]};
//       border-bottom: 2px solid ${({ theme }) => theme.palette.primary[0]};
//     }
//   }
// `


export default SearchSelector
